import { useState } from "react";
import { Loader2, ScanEye, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "adm-vr-prompt-";

// end of a generation: the free screenshots are prepared automatically, the paid analysis is only proposed
export default function ReviewPrompt({ rev, onOpen }) {
  const [, setTick] = useState(0);
  if (!rev || rev.trigger !== "generation" || !["rendering", "rendered"].includes(rev.status) || rev.pages_analyzed) return null;
  if (localStorage.getItem(KEY + rev.id)) return null;
  const close = () => { localStorage.setItem(KEY + rev.id, "1"); setTick((n) => n + 1); };
  const busy = rev.status === "rendering";
  return (
    <div className="fixed bottom-4 left-4 z-30 w-[min(380px,calc(100vw-2rem))] rounded-xl border border-sky-200 bg-white p-4 shadow-xl" data-testid="review-prompt">
      <button className="absolute right-2 top-2 p-1 text-slate-400 hover:text-slate-700" onClick={close} aria-label="Chiudi" data-testid="review-prompt-close-btn"><X size={14} /></button>
      <p className="flex items-center gap-2 pr-6 text-sm font-semibold text-slate-900">
        {busy ? <Loader2 size={15} className="animate-spin text-sky-600" /> : <ScanEye size={15} className="text-sky-700" />}
        {busy ? "Revisione visiva in preparazione" : "Vuoi avviare la revisione visiva?"}
      </p>
      <p className="mt-1.5 text-xs text-slate-600" data-testid="review-prompt-text">
        {busy ? "Scatto gli screenshot desktop e mobile della nuova demo (gratis, 1-2 minuti). Poi potrai far analizzare il design all'AI."
          : `Screenshot pronti (${rev.pages_total} ${rev.pages_total === 1 ? "pagina" : "pagine"}). L'AI li analizza come un art director e propone correzioni: vedi la stima prima e nulla viene speso senza la tua conferma.`}
      </p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" className="bg-sky-600 hover:bg-sky-700" onClick={onOpen} data-testid="review-prompt-open-btn"><ScanEye size={14} className="mr-1.5" />Apri revisione</Button>
        <Button size="sm" variant="ghost" onClick={close} data-testid="review-prompt-dismiss-btn">Non ora</Button>
      </div>
    </div>
  );
}
